import { PostingsState } from "@reducers/types/HRM/postings-state";

import { PostingActions } from "@actions/HRM/employee/postings-action";
import {
  GET_POSTINGS,
  UPDATE_ABROAD_POSTING_INFO,
  UPDATE_DEPUTATION_POSTING_INFO,
  UPDATE_POSTING_RECORD_POSTING_INFO,
  UPDATE_FOREIGN_TRAVEL_POSTING_INFO,
  DELETE_ABROAD_POSTING_INFO,
  DELETE_DEPUTATION_POSTING_INFO,
  DELETE_POSTING_RECORD_POSTING_INFO,
  DELETE_FOREIGN_TRAVEL_POSTING_INFO,
} from "@actions/HRM/employee/types";

import {
  getInitialState,
  getFailedState,
  getRequestingState,
  getSuccessState,
} from "@utils/store";

const initialState: PostingsState = { ...getInitialState() };

const resetStates = {
  updateAbroadPostingSuccess: false,
  updateAbroadPostingFailed: false,

  updateDeputationPostingSuccess: false,
  updateDeputationPostingFailed: false,

  updatePostingRecordPostingSuccess: false,
  updatePostingRecordPostingFailed: false,

  updateForeignTravelPostingSuccess: false,
  updateForeignTravelPostingFailed: false,

  deleteAbroadPostingSuccess: false,
  deleteAbroadPostingFailed: false,

  deleteDeputationPostingSuccess: false,
  deleteDeputationPostingFailed: false,

  deletePostingRecordPostingSuccess: false,
  deletePostingRecordPostingFailed: false,

  deleteForeignTravelPostingSuccess: false,
  deleteForeignTravelPostingFailed: false,
};

const postingsReducer = (
  state = initialState,
  action: PostingActions,
): PostingsState => {
  switch (action.type) {
    case GET_POSTINGS.GET_POSTINGS_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          getPostingRequestOngoing: true,
          getPostingSuccess: false,
          getPostingFailed: false,
        }),
      };
    }

    case GET_POSTINGS.GET_POSTINGS_SUCCESS: {
      const { payload } = action as any;
      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: payload.data,
          getPostingRequestOngoing: false,
          getPostingSuccess: true,
          getPostingFailed: false,
        }),
      };
    }

    case GET_POSTINGS.GET_POSTINGS_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          getPostingRequestOngoing: true,
          getPostingSuccess: false,
          getPostingFailed: true,
        }),
      };
    }

    case UPDATE_ABROAD_POSTING_INFO.UPDATE_ABROAD_POSTING_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateAbroadPostingRequestOngoing: true,
          updateAbroadPostingSuccess: false,
          updateAbroadPostingFailed: false,
        }),
      };

    case UPDATE_ABROAD_POSTING_INFO.UPDATE_ABROAD_POSTING_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentAbroadPostings =
        state && state.data && state.data.postingAbroads
          ? state.data.postingAbroads
          : [];
      let updatedAbroadPostings = currentAbroadPostings;

      const indexOfNewAbroadPosting = currentAbroadPostings.findIndex(
        (abroadPosting: any) => abroadPosting.id === payload.data.id,
      );
      if (indexOfNewAbroadPosting === -1)
        updatedAbroadPostings.push(payload.data);
      else updatedAbroadPostings[indexOfNewAbroadPosting] = payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["postingAbroads"] = updatedAbroadPostings;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateAbroadPostingRequestOngoing: false,
          updateAbroadPostingSuccess: true,
          updateAbroadPostingFailed: false,
        }),
      };
    }

    case UPDATE_ABROAD_POSTING_INFO.UPDATE_ABROAD_POSTING_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateAbroadPostingRequestOngoing: false,
          updateAbroadPostingSuccess: false,
          updateAbroadPostingFailed: true,
        }),
      };
    }

    case UPDATE_DEPUTATION_POSTING_INFO.UPDATE_DEPUTATION_POSTING_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateDeputationPostingRequestOngoing: true,
          updateDeputationPostingSuccess: false,
          updateDeputationPostingFailed: true,
        }),
      };

    case UPDATE_DEPUTATION_POSTING_INFO.UPDATE_DEPUTATION_POSTING_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentDeputationPostings =
        state && state.data && state.data.deputationPostings
          ? state.data.deputationPostings
          : [];
      let updatedDeputationPostings = currentDeputationPostings;

      const indexOfNewDeputationPosting = currentDeputationPostings.findIndex(
        (deputationPosting: any) => deputationPosting.id === payload.data.id,
      );
      if (indexOfNewDeputationPosting === -1)
        updatedDeputationPostings.push(payload.data);
      else
        updatedDeputationPostings[indexOfNewDeputationPosting] = payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["deputationPostings"] = updatedDeputationPostings;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateDeputationPostingRequestOngoing: false,
          updateDeputationPostingSuccess: true,
          updateDeputationPostingFailed: false,
        }),
      };
    }

    case UPDATE_DEPUTATION_POSTING_INFO.UPDATE_DEPUTATION_POSTING_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateDeputationPostingRequestOngoing: false,
          updateDeputationPostingSuccess: false,
          updateDeputationPostingFailed: true,
        }),
      };
    }

    case UPDATE_POSTING_RECORD_POSTING_INFO.UPDATE_POSTING_RECORD_POSTING_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updatePostingRecordPostingRequestOngoing: true,
          updatePostingRecordPostingSuccess: false,
          updatePostingRecordPostingFailed: false,
        }),
      };

    case UPDATE_POSTING_RECORD_POSTING_INFO.UPDATE_POSTING_RECORD_POSTING_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentPostingRecordPostings =
        state && state.data && state.data.postingRecords
          ? state.data.postingRecords
          : [];
      let updatedPostingRecordPostings = currentPostingRecordPostings;

      const indexOfNewPostingRecordPosting =
        currentPostingRecordPostings.findIndex(
          (postingRecordPosting: any) =>
            postingRecordPosting.id === payload.data.id,
        );
      if (indexOfNewPostingRecordPosting === -1)
        updatedPostingRecordPostings.push(payload.data);
      else
        updatedPostingRecordPostings[indexOfNewPostingRecordPosting] =
          payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["postingRecords"] = updatedPostingRecordPostings;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updatePostingRecordPostingRequestOngoing: false,
          updatePostingRecordPostingSuccess: true,
          updatePostingRecordPostingFailed: false,
        }),
      };
    }

    case UPDATE_POSTING_RECORD_POSTING_INFO.UPDATE_POSTING_RECORD_POSTING_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updatePostingRecordPostingRequestOngoing: false,
          updatePostingRecordPostingSuccess: false,
          updatePostingRecordPostingFailed: true,
        }),
      };
    }

    case UPDATE_FOREIGN_TRAVEL_POSTING_INFO.UPDATE_FOREIGN_TRAVEL_POSTING_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateForeignTravelPostingRequestOngoing: true,
          updateForeignTravelPostingSuccess: false,
          updateForeignTravelPostingFailed: false,
        }),
      };

    case UPDATE_FOREIGN_TRAVEL_POSTING_INFO.UPDATE_FOREIGN_TRAVEL_POSTING_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentForeignTravelPostings =
        state && state.data && state.data.foreignTravels
          ? state.data.foreignTravels
          : [];
      let updatedForeignTravelPostings = currentForeignTravelPostings;

      const indexOfNewForeignTravelPosting =
        currentForeignTravelPostings.findIndex(
          (foreignTravelPosting: any) =>
            foreignTravelPosting.id === payload.data.id,
        );
      if (indexOfNewForeignTravelPosting === -1)
        updatedForeignTravelPostings.push(payload.data);
      else
        updatedForeignTravelPostings[indexOfNewForeignTravelPosting] =
          payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["foreignTravels"] = updatedForeignTravelPostings;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateForeignTravelPostingRequestOngoing: false,
          updateForeignTravelPostingSuccess: true,
          updateForeignTravelPostingFailed: false,
        }),
      };
    }

    case UPDATE_FOREIGN_TRAVEL_POSTING_INFO.UPDATE_FOREIGN_TRAVEL_POSTING_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateForeignTravelPostingRequestOngoing: false,
          updateForeignTravelPostingSuccess: false,
          updateForeignTravelPostingFailed: true,
        }),
      };
    }

    case DELETE_ABROAD_POSTING_INFO.DELETE_ABROAD_POSTING_INFO_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteAbroadPostingRequestOngoing: true,
          deleteAbroadPostingSuccess: false,
          deleteAbroadPostingFailed: false,
        }),
      };
    }

    case DELETE_ABROAD_POSTING_INFO.DELETE_ABROAD_POSTING_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedAbroadPostingsInfo =
        state && state.data && state.data.postingAbroads
          ? state.data.postingAbroads.filter(
              (abroadPosting: any) => abroadPosting.id !== payload.data.id,
            )
          : [];

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["postingAbroads"] = updatedAbroadPostingsInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteAbroadPostingRequestOngoing: false,
          deleteAbroadPostingSuccess: true,
          deleteAbroadPostingFailed: false,
        }),
      };
    }

    case DELETE_ABROAD_POSTING_INFO.DELETE_ABROAD_POSTING_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deleteAbroadPostingRequestOngoing: false,
          deleteAbroadPostingSuccess: false,
          deleteAbroadPostingFailed: true,
        }),
      };
    }

    case DELETE_DEPUTATION_POSTING_INFO.DELETE_DEPUTATION_POSTING_INFO_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteDeputationPostingRequestOngoing: true,
          deleteDeputationPostingSuccess: false,
          deleteDeputationPostingFailed: false,
        }),
      };
    }

    case DELETE_DEPUTATION_POSTING_INFO.DELETE_DEPUTATION_POSTING_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedDeputationPostingsInfo =
        state && state.data && state.data.deputationPostings
          ? state.data.deputationPostings.filter(
              (deputationPosting: any) =>
                deputationPosting.id !== payload.data.id,
            )
          : [];

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["deputationPostings"] = updatedDeputationPostingsInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteDeputationPostingRequestOngoing: false,
          deleteDeputationPostingSuccess: true,
          deleteDeputationPostingFailed: false,
        }),
      };
    }

    case DELETE_DEPUTATION_POSTING_INFO.DELETE_DEPUTATION_POSTING_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deleteDeputationPostingRequestOngoing: false,
          deleteDeputationPostingSuccess: false,
          deleteDeputationPostingFailed: true,
        }),
      };
    }

    case DELETE_POSTING_RECORD_POSTING_INFO.DELETE_POSTING_RECORD_POSTING_INFO_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deletePostingRecordPostingRequestOngoing: true,
          deletePostingRecordPostingSuccess: false,
          deletePostingRecordPostingFailed: false,
        }),
      };
    }

    case DELETE_POSTING_RECORD_POSTING_INFO.DELETE_POSTING_RECORD_POSTING_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedPostingRecordPostingsInfo =
        state && state.data && state.data.postingRecords
          ? state.data.postingRecords.filter(
              (postingRecordPosting: any) =>
                postingRecordPosting.id !== payload.data.id,
            )
          : [];

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["postingRecords"] = updatedPostingRecordPostingsInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deletePostingRecordPostingRequestOngoing: false,
          deletePostingRecordPostingSuccess: true,
          deletePostingRecordPostingFailed: false,
        }),
      };
    }

    case DELETE_POSTING_RECORD_POSTING_INFO.DELETE_POSTING_RECORD_POSTING_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deletePostingRecordPostingRequestOngoing: false,
          deletePostingRecordPostingSuccess: false,
          deletePostingRecordPostingFailed: true,
        }),
      };
    }

    case DELETE_FOREIGN_TRAVEL_POSTING_INFO.DELETE_FOREIGN_TRAVEL_POSTING_INFO_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteForeignTravelPostingRequestOngoing: true,
          deleteForeignTravelPostingSuccess: false,
          deleteForeignTravelPostingFailed: false,
        }),
      };
    }

    case DELETE_FOREIGN_TRAVEL_POSTING_INFO.DELETE_FOREIGN_TRAVEL_POSTING_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedForeignTravelPostingsInfo =
        state && state.data && state.data.foreignTravels
          ? state.data.foreignTravels.filter(
              (foreignTravelPosting: any) =>
                foreignTravelPosting.id !== payload.data.id,
            )
          : [];

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["foreignTravels"] = updatedForeignTravelPostingsInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteForeignTravelPostingRequestOngoing: false,
          deleteForeignTravelPostingSuccess: true,
          deleteForeignTravelPostingFailed: false,
        }),
      };
    }

    case DELETE_FOREIGN_TRAVEL_POSTING_INFO.DELETE_FOREIGN_TRAVEL_POSTING_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deleteForeignTravelPostingRequestOngoing: false,
          deleteForeignTravelPostingSuccess: false,
          deleteForeignTravelPostingFailed: true,
        }),
      };
    }

    default:
      return state;
  }
};

export default postingsReducer;
